/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {motion} from "motion/react";

class InfoDialogComponent extends Component {

    componentDidMount() {
        setTimeout(() => {
            if (this.props.close !== undefined) {
                this.props.close()
            }
        }, ((this.props.closeTimeout ?? 5) * 1000))
    }

    render() {
        return (
            <div aria-live="assertive"
                 className="fixed inset-0 flex items-end  px-4 py-6 pointer-events-none sm:p-6">
                <div className="w-full flex flex-col items-center">
                    <motion.div positionTransition
                                initial={{y: 12, scale: 0.7}}
                                animate={{y: 0, scale: 1}}
                                exit={{y: 12, scale: 0.3, opacity: 0}}
                                transition={{
                                    type: "spring",
                                    damping: 13,
                                    stiffness: 200,
                                    restDelta: 0.001
                                }}
                                className="max-w-sm w-full  shadow-lg rounded-lg pointer-events-auto bg-black hover:opacity-60 opacity-90 overflow-hidden z-50">
                        <div className="flex items-start">
                            <div className=" w-0 flex-1 p-4">
                                <p className="text-2xl font-medium text-white text-center">{this.props.title}</p>
                            </div>
                        </div>

                    </motion.div>
                </div>
            </div>
        );
    }
}

InfoDialogComponent.propTypes = {};

export default InfoDialogComponent;